export const TRAVEL_DURATION_UPDATED = 'TRAVEL_DURATION_UPDATED_EVENT'
